

















































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";

@Component({
	computed: {
		...mapGetters("users", ["userInfo"]),
		...mapGetters("project", [
			"isLoading",
			"isLoadingUser",
			"projects",
			"userProjects",
			"joinedProjects",
			"isJoinedLoading",
			"joinNotifications"
		])
	},
	methods: {
		...mapActions("project", [
			"getAllProjects",
			"getUserProjects",
			"getJoinedProjects",
			"applyJoin",
			"joinNotification",
			"acceptJoin",
			"rejectJoin"
		])
	}
})
export default class Project extends Vue {
	search = "";
	searchUserProjects = "";
	searchJoinedProjects = "";
	isLoading!: boolean;
	isLoadingUser!: boolean;
	isJoinedLoading!: boolean;
	userInfo!: any;
	projects!: [any];
	userProjects!: [any];
	joinedProjects!: [any];
	joinNotifications!: [any];
	getAllProjects!: any;
	getUserProjects!: any;
	getJoinedProjects!: any;
	applyJoin!: any;
	acceptJoin!: any;
	rejectJoin!: any;
	loadingproj!: any;

	tab = 1;

	fav = true;
	menu = false;
	message = false;
	hints = true;

	mounted() {
		this.getAllProjects();
		this.getUserProjects(this.userInfo.id);
		this.getJoinedProjects();
	}

	refreshProject() {
		this.getAllProjects();
		this.getUserProjects(this.userInfo.id);
		this.getJoinedProjects();
		this.$vs.notification({
			icon: "<i class='bx bx-refresh'></i>",
			color: "primary",
			position: "bottom-right",
			title: "Refresh Data",
			text: `fetching requried datas...`
		});
	}

	toggleTab(tab: number) {
		this.tab = tab;
		this.getAllProjects();
		this.getUserProjects(this.userInfo.id);
		this.getJoinedProjects();
	}

	isTab(tab: number) {
		return this.tab == tab;
	}

	openChat(id: string) {
		this.$router.push({ name: "Chat", params: { id } });
	}

	seeDetail(title: string) {
		this.$router.push({ name: "ProjectDetail", params: { id: title } });
	}

	set filteredUserProjects(val: any) {
		this.userProjects = val;
	}
	get filteredUserProjects() {
		const p = this.userProjects.filter((project: any) => {
			return project.title.toLowerCase().match(this.searchUserProjects);
		});
		return p;
	}

	set filteredProjects(val: any) {
		this.projects = val;
	}
	get filteredProjects() {
		const p = this.projects.filter((project: any) => {
			return project.title.toLowerCase().match(this.search);
		});
		return p;
	}

	set filteredJoinedProjects(val: any) {
		this.joinedProjects = val;
	}
	get filteredJoinedProjects() {
		const jp = this.joinedProjects.filter((project: any) => {
			return project.title.toLowerCase().match(this.search);
		});
		return jp;
	}

	// apply to join project
	applyJoinProject(id: string) {
		this.applyJoin(id)
			.then(() => {
				this.$store.dispatch("snackbar", "Join request send successfully!");
			})
			.catch((err: any) => {
				this.$store.dispatch("snackbar", "Join request have been sent...");
			});
	}

	acceptJoinProject(project: any) {
		const {
			projectid: { title, _id },
			userid: { name },
			userid
		} = project;

		this.acceptJoin({ projectid: _id, userid: userid._id })
			.then(() => {
				this.$store.dispatch(
					"snackbar",
					`${name} Joined project ${title} successfully!`
				);
			})
			.catch((err: any) => {
				this.$store.dispatch(
					"snackbar",
					`${name} Joined project ${title} successfully!`
				);
			});
	}

	rejectJoinProject(project: any) {
		console.log(project);
		const {
			projectid: { title, _id },
			userid: { name },
			userid
		} = project;

		this.rejectJoin({ projectid: _id, userid: userid._id })
			.then(() => {
				this.$store.dispatch(
					"snackbar",
					`${name}'s request has been rejected successfully for project ${title}!`
				);
			})
			.catch((err: any) => {
				this.$store.dispatch(
					"snackbar",
					`${name}'s request has been rejected successfully for project ${title}!`
				);
			});
	}
}
